export default "__VITE_ASSET__CUATXQAR__"